import { useEffect, useState } from 'react'

export function useActivityTimelineOpen(streaming, isDrafting) {
  const [open, setOpen] = useState(true)
  useEffect(() => {
    if (isDrafting) setOpen(false)
  }, [isDrafting])
  const expanded = streaming && !isDrafting ? true : open
  return { expanded, onToggle: () => setOpen((value) => !value) }
}
